import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as moment from 'moment';
import { AuctionList } from './interface/auction-list';
import { AuctionsFilter } from 'src/app/features/bidders/core/enums/auctions_filter';
import { AuctionsService } from 'src/app/features/rooms/core/service/auctions.service';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from 'src/app/core/service/config.service';
import { MatDialog } from '@angular/material/dialog';
import { ApiRoomsService } from 'src/app/features/rooms/core/service/api-rooms.service';
import { PageEvent } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-auction-listing',
  templateUrl: './auction-listing.component.html',
  styles: [
  ]
})
export class AuctionListingComponent implements OnInit {
  @Input() title = "Auction List"
  @Input() IsRoom: boolean = false
  @Input() showFilterBar: boolean = true
  @Input() Reload: number = 1
  @Output() OpenAddAuctionItem = new EventEmitter<boolean>();
  @Output() Loading = new EventEmitter<boolean>(true);

  user = localStorage.getItem("auth")
  authUser: any = this.user ? JSON.parse(this.user) : null;
  AuctionListFilter: AuctionList = {
    is_active: 1,
    search: "",
    sort: "ASC",
    // sortBy: 'created_at',
    start_date: "",
    end_date: "",
    type: "upcoming",
    user_id: this._activeRoute.snapshot.params['id'] ? this._activeRoute.snapshot.params['id'] : this.authUser?.user?.id,
    room_id: this._activeRoute.snapshot.params['id'],
    page: 0,
    perPage: 10
  }

  filterItems: any = [
    {
      key: AuctionsFilter.upcomming,
      value: "Home.Upcoming",
      canLoadMore: true,
      sortBy: [{ key: this.translate.instant('items-requests.starting first'), value: "ASC" }, { key: this.translate.instant('items-requests.last one starting'), value: "DESC" }],
      count: 0
    },
    {
      key: AuctionsFilter.ongoing,
      value: "Home.Ongoing",
      canLoadMore: true,
      sortBy: [{ key: this.translate.instant('items-requests.sooner one will end'), value: "ASC" }, { key: this.translate.instant('items-requests.last one will end'), value: "DESC" }],
      count: 0
    },
    {
      key: AuctionsFilter.completed,
      value: "Home.Completed",
      canLoadMore: true,
      sortBy: [{ key: this.translate.instant('items-requests.first one ended'), value: "ASC" }, { key: this.translate.instant('items-requests.last one is ended'), value: "DESC" }],
      count: 0
    }
  ]
  sortingList = this.filterItems[0].sortBy
  sortByText = this.filterItems[0].sortBy[0].key
  showSearch: boolean = false;
  showFilter: boolean = false;
  total: number = 0;
  AuctionList!: any[]
  loadMore: boolean = false;
  loadingData: boolean = false;
  responsCounts!: { upcoming: number, completed: number, ongoing: number };
  categoriesList: any[] = [];
  constructor(private auctionService: AuctionsService,
    private _RoomService: ApiRoomsService,
    private _activeRoute: ActivatedRoute,
    public translate: TranslateService,
    private _config: ConfigService,
    private dialog: MatDialog) {
  }

  ngOnInit(): void {
    console.log("Auth User", this.authUser);
    if (this.IsRoom) {
      delete this.AuctionListFilter.type;
      this.sortingList = [{ key: "sort.starting first", value: "ASC", type: "start_at" },
      { key: "sort.category", value: "ASC", type: "category" },
      { key: "sort.minimum bid", value: "ASC", type: "minimum_price" },
      { key: "sort.maximum bid", value: "DESC", type: "minimum_price" }];
      this.sortByText = this.sortingList[0].key;
    }
    this.GetAuctions()
    this.Getcategories();

    this.auctionService.getLoadListValue().subscribe((res) => {
      if (res) {
        this.GetAuctions()
      }
    })
  }

  ngOnChanges(changes: any): void {
    if (changes?.Reload) {
      this.GetAuctions()
    }
  }
  changeTime(value: any) {
    return moment(value).format();
  }

  getTypeTimer(startData: any, endDate: any) {

    let statusTimer: any = 'end';
    let startDateTimer = moment.utc(startData).local().format();
    let endDateTimer = moment.utc(endDate).local().format();

    if (moment().isBefore(moment().format(startDateTimer))) {
      statusTimer = 'upcoming';
    }
    if (moment().isAfter(moment().format(startDateTimer)) && moment().isBefore(moment().format(endDateTimer))) {
      statusTimer = 'ongoing';
    }

    return statusTimer;
  }

  GetAuctions(next: boolean = false) {
    console.log(this.AuctionListFilter);
    // this.AuctionList = []

    let modal = { ...this.AuctionListFilter }
    modal.page += 1
    this.loadingData = true

    if (this.IsRoom) {
      this._RoomService.GetRoomAuctions(modal).subscribe({
        next: (res) => {
          this.Loading.emit(false)
          this.loadMore = false
          this.loadingData = false

          // this.filterItems[0].count = res?.data?.total_upcoming
          // this.filterItems[1].count = res?.data?.total_ongoing
          // this.filterItems[2].count = res?.data?.total_completed
          this.AuctionList = res.data.list;
          this.total = res.data.total
          this.auctionService.LoadListNow.next(false)
        },
        error: (err) => {
          this.Loading.emit(false)
          this.loadMore = false
          this.loadingData = false
          this._config.showErrors(err);
          this.auctionService.LoadListNow.next(false)
        }
      })
    }
    else {
      // delete this.AuctionListFilter.room_id
      this.auctionService.GetUserAuctions(this.AuctionListFilter).subscribe({
        next: (res) => {
          this.Loading.emit(false)
          this.loadMore = false
          this.loadingData = false
          this.filterItems[0].count = res?.data?.total_upcoming
          this.filterItems[1].count = res?.data?.total_ongoing
          this.filterItems[2].count = res?.data?.total_completed
          // if (next) {
          //   this.AuctionList.concat(res.data.list);
          // } else {
          this.AuctionList = res.data.list;
          // }
          this.total = res.data.total
          if (!res.data.list.length) {
            this.filterItems.forEach((item: any) => item.key == this.AuctionListFilter.type ? item.canLoadMore = false : item.key = item.key)
          }
          this.auctionService.LoadListNow.next(false)
        }, error: (error) => {
          this.Loading.emit(false)
          this._config.showErrors(error);
          this.loadMore = false
          this.loadingData = false
          this.auctionService.LoadListNow.next(false)
        }
      }
      )
    }


    if (this.IsRoom) {

    } else {

    }

  }

  onSelectType(item: any, index: number) {
    this.AuctionListFilter.type = item.key;
    this.sortingList = item.sortBy;
    this.sortByText = this.filterItems[index].sortBy[0].key

    this.GetAuctions()
  }

  OnSelectSort(item: any) {
    this.AuctionListFilter.sort = item.value;
    if (item.type) {
      this.AuctionListFilter.sortBy = item.type;
    }
    this.sortByText = item.key;
    this.GetAuctions()
  }

  onClearFiltrs() {
    this.AuctionListFilter.start_date = "";
    this.AuctionListFilter.end_date = "";
    delete this.AuctionListFilter?.category_id;
    delete this.AuctionListFilter?.filterType;
    delete this.AuctionListFilter?.isPublished;
    delete this.AuctionListFilter?.status;
    this.GetAuctions()
  }

  onApplyDate(type: 'start' | 'end') {
    switch (type) {
      case 'start':
        this.AuctionListFilter.start_date
        break;
      case 'end':

        break;
    }
  }

  onCancelSearch() {
    this.showSearch = !this.showSearch
    if (this.AuctionListFilter.search && !this.showSearch) {
      this.AuctionListFilter.search = ''
      this.GetAuctions()
    }
  }

  Getcategories() {
    this.loadingData = true;
    this.auctionService.getCategories().subscribe(
      response => {
        this.loadingData = false;
        this.categoriesList = response.data.list
      },
      error => {
        this.loadingData = false;
        this._config.showErrors(error)
      }
    )
  }

  handlePageEvent(event: PageEvent) {
    this.AuctionListFilter.perPage = event.pageSize;
    this.AuctionListFilter.page = event.pageIndex;
    // this.filter();
    this.GetAuctions();
  }


  OnToggleSearch() {
    this.showSearch = !this.showSearch;
    if (!this.showSearch) {
      this.AuctionListFilter.search = '';
      this.GetAuctions();
    }

  }

  OnSearchText() {
    this.AuctionListFilter.page = 0;
    this.GetAuctions();
  }

}
